import { render, staticRenderFns } from "./discountPast.vue?vue&type=template&id=50f94668&scoped=true"
import script from "./discountPast.vue?vue&type=script&lang=js"
export * from "./discountPast.vue?vue&type=script&lang=js"
import style0 from "./discountPast.vue?vue&type=style&index=0&id=50f94668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f94668",
  null
  
)

export default component.exports